module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "mx-auto"
  }, [_c('img', {
    staticClass: "logo",
    staticStyle: {
      "height": "68px"
    },
    attrs: {
      "src": require("../../assets/img/logo-mini.png"),
      "alt": "SolarSpot logo"
    }
  }), _vm._v(" "), _c('v-card-title', {
    attrs: {
      "primary-title": ""
    }
  }, [_c('div', [_c('h3', {
    staticClass: "headline mb-0"
  }, [_vm._v("Zaloguj się")])])]), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "form",
    attrs: {
      "lazy-validation": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "rules": _vm.emailRules,
      "label": "E-mail",
      "required": ""
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "append-icon": _vm.e3 ? 'visibility' : 'visibility_off',
      "append-icon-cb": function () { return (_vm.e3 = !_vm.e3); },
      "type": _vm.e3 ? 'password' : 'text',
      "name": "input-10-2",
      "label": "Hasło",
      "hint": "At least 8 characters",
      "min": "8",
      "value": "",
      "required": ""
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  }), _vm._v(" "), _c('v-btn', {
    on: {
      "click": _vm.login
    }
  }, [_vm._v("\n              Zaloguj się\n            ")]), _vm._v(" "), _c('v-btn', {
    on: {
      "click": _vm.register
    }
  }, [_vm._v("\n              Przypomnij hasło\n            ")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "timeout": 6000,
      "top": true,
      "bottom": false,
      "right": false,
      "left": false,
      "multi-line": false,
      "vertical": true
    },
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.error) + "\n    "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "pink"
    },
    nativeOn: {
      "click": function($event) {
        _vm.snackbar = false
      }
    }
  }, [_vm._v("Close")])], 1), _vm._v(" "), (_vm.ready) ? _c('div', {
    staticClass: "overlay"
  }, [_c('div', {
    staticClass: "flex-spinner"
  }, [_c('v-progress-circular', {
    attrs: {
      "size": 200,
      "width": 7,
      "indeterminate": "",
      "color": "amber"
    }
  })], 1)]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6fe6bde6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/auth/Login.vue
// module id = 159
// module chunks = 1